/**
 *  Commented because we have no more
 *  date to close the registrations
 */
// import isAfter from 'date-fns/isAfter';

export const state = () => ({
    /**
     *  Commented because we have no more
     *  date to close the registrations
     */
    // isAfterEvent: isAfter(new Date(Date.now()), new Date(2022, 1, 2)),
    isAfterEvent: false,
});

export const getters = {
    isAfterEvent: (states) => states.isAfterEvent,
};

export const mutations = {
    ['SET_IS_AFTER_EVENT'](states, value) {
        states.isAfterEvent = value;
    },
};

export const actions = {
    validateDate({ commit }) {
        /**
         *  Commented because we have no more
         *  date to close the registrations
         */
        // const dateAfterEvent = isAfter(new Date(Date.now()), new Date(2022, 1, 2));
        const dateAfterEvent = false;

        if (dateAfterEvent) {
            commit('SET_IS_AFTER_EVENT', true);
        }
    },
};


export default {
    state,
    getters,
    mutations,
    actions,
};